import SubmitForm from "./../components/submit-form/presenter/submit-form.js";
import {RuleName} from "./../components/submit-form/const.js";

const formElement = document.querySelector(`.calculate-form`);
const submitFormComponent = new SubmitForm({
  formElement,
});

const elementRules = [
  {
    name: `workers-count`,
    rules: [
      RuleName.MORE_THAN_ZERO,
    ]
  },
  {
    name: `shifts-count`,
    rules: [
      RuleName.MORE_THAN_ZERO,
    ]
  },
  {
    name: `worker-salary`,
    rules: [
      RuleName.MORE_THAN_ZERO,
    ]
  },
  {
    name: `product-type`
  },
  {
    name: `email`,
    rules: [
      RuleName.EMAIL
    ]
  },
  {
    name: `phone`,
    rules: [
      RuleName.PHONE
    ]
  },
  {
    name: `name`,
    rules: [
      RuleName.NOT_EMPTY
    ]
  }
];

submitFormComponent.init(elementRules);
